export default {
    path: '/IsEnterprise',
    name: 'IsEnterprise',
    component: () =>
        import(/* webpackChunkName: "IsEnterprise" */ "@/pages/companyApply/index.vue"),
   
}